module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.54,0H29.92C33,0,35,2.09,35,5.29V21.2a4.88,4.88,0,0,1-5,5.19c-3.82,0-7.65,0-11.47,0a1.13,1.13,0,0,0-.95.43c-2.19,2.54-4.39,5.06-6.59,7.59A1.27,1.27,0,0,1,10,35c-.62,0-1-.54-1-1.32,0-2.2,0-4.41,0-6.61,0-.56-.15-.66-.64-.65-1.17,0-2.35,0-3.52,0a4.84,4.84,0,0,1-4.8-5Q0,13.24,0,5.05a4.84,4.84,0,0,1,4.8-5c4.24,0,8.48,0,12.73,0ZM11.12,30.78l.12,0,.33-.39c1.64-1.89,3.3-3.77,4.94-5.67a1.47,1.47,0,0,1,1.22-.59L30,24.13a2.68,2.68,0,0,0,2.83-2.95c0-1.5,0-3,0-4.51,0-3.87,0-7.74,0-11.61a2.62,2.62,0,0,0-2.7-2.8Q17.54,2.28,5,2.31A2.65,2.65,0,0,0,2.17,5.24v16a2.69,2.69,0,0,0,2.88,3c1.63,0,3.25,0,4.88,0a1.1,1.1,0,0,1,1.19,1.24v5.35Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.5,19.4H7.91a1.16,1.16,0,0,1-.83-2,.89.89,0,0,1,.68-.31c1.75,0,3.5,0,5.25,0,2.14,0,4.28,0,6.41,0,2,0,3.94,0,5.91,0,.61,0,1.21.06,1.81,0a1.1,1.1,0,0,1,1.15,1.12,1.16,1.16,0,0,1-1.14,1.14l-8.19,0H17.5Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.51,14.7H8.2a4.35,4.35,0,0,1-.51,0,1.08,1.08,0,0,1-1-1.08,1.1,1.1,0,0,1,1-1.14c.15,0,.3,0,.45,0q9.37,0,18.74,0a3.38,3.38,0,0,1,.45,0,1.09,1.09,0,0,1,.94,1.11,1.07,1.07,0,0,1-1,1.1,4.26,4.26,0,0,1-.5,0Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M12.71,7.79h4.73a1.05,1.05,0,0,1,1.08.77,1.11,1.11,0,0,1-.31,1.19,1.08,1.08,0,0,1-.79.28H7.86a1.12,1.12,0,1,1,0-2.24Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3132e5a","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/comment.vue
// module id = c085f7c26dfb26ec0b5e
// module chunks = 89